import React from 'react';
import { DayPicker } from 'react-day-picker';
import { formatDate, parseDate } from '../../utils/utilities';
import moment from 'moment';
import classNames from 'classnames';
import Cleave from 'cleave.js/dist/cleave-react';
import { Row, Col } from 'react-bootstrap'

import Loading from '../../components/shared/Loading'
import ConvertibleText from '../../components/shared/ConvertibleText'


class MinimumPremium extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            minimumEarnedPremium : props.limits.minimumEarnedPremium,
            date : props.limits.minimumEarnedPremiumDate
        };
        this.onBlurHandler = this.onBlurHandler.bind(this)
        this.handleDate = this.handleDate.bind(this)
        this.handleDateChange = this.handleDateChange.bind(this)
        this.handleOpenCalendar = this.handleOpenCalendar.bind(this)
    }
    componentWillReceiveProps(nextProps){
        this.setState({
            minimumEarnedPremium : (nextProps.limits.minimumEarnedPremium>100) ?
            this.state.minimumEarnedPremium : nextProps.limits.minimumEarnedPremium
        })

    }

    componentDidUpdate(prevProps) {
        if (prevProps.limits?.minimumEarnedPremiumDate !== this.props.limits?.minimumEarnedPremiumDate) {
            this.setState({
                date: this.props.limits?.minimumEarnedPremiumDate
            })
        }
    }

    onBlurHandler(priceValue) {
        this.props.onBlurHandler(priceValue)
    }

    handleOpenCalendar() {
        if (this.state.openC !== true) {
            this.setState({
                openC: true
            })
        } else {
            this.setState({
                openC: false
            })
        }
    }

    handleDate(day) {
        if (day) {
            this.setState({ date: day, openC: false});
            this.onBlurHandler({minimumEarnedPremiumDate: moment(day).format('MM/DD/YYYY')})
        }
     }

    handleDateChange(event) {
        if(event.target.value.length === 10) {
        this.setState({ date: event.target.value });
        this.onBlurHandler({minimumEarnedPremiumDate: moment(event.target.value).format('MM/DD/YYYY')})
        } else {
            this.setState({ dateHolder: event.target.value, date:'' });
            this.onBlurHandler({minimumEarnedPremiumDate: ''})
        }
    }

    render() {
        const { isModified, manuallySetPricing, /*limits: { minimumEarnedPremium = {}} = {}, type*/ } = this.props
        let modifiedDate = new Date(this.state.date);
        return (
            <div className="gcLimitsContainer">
                <h4 className="quoteTitle">Minimum Premium</h4>
                <div>
                    <Row>
                        <Col xs={8} md={6}>
                            <div className="premiumGrid">
                                <span className="h5">Earned %</span>
                                <span className="h4">{ 
                                    isModified 
                                    ? <Loading width="23px" height="23px" /> 
                                    : <ConvertibleText 
                                        manuallySetPricing={manuallySetPricing}  
                                        value={{
                                            changePrefix: true,
                                            name: 'minimumEarnedPremium',
                                            text: this.state.minimumEarnedPremium
                                        }} 
                                        onBlurHandler={this.onBlurHandler}
                                    />
                                    }
                                </span>
                            </div>
                        </Col>
                        </Row>
                        {this.props.type === 'oi' && <Row>
                        <Col xs={8} md={6}>
                            <div className="premiumGrid">
                                <span className="h5" style={{paddingTop: "10px"}}>Project Specific - Fully Earned Premium Date</span>
                                <span className="h4">{ 
                                    isModified 
                                    ? <Loading width="23px" height="23px" /> 
                                    : (<div className="modalDatePicker col-xs-12"><div className='row' style={{marginLeft:'0px'}}>
                                    <Cleave
                                    id={'effDate'}
                                    className={classNames(
                                        'form-control',
                                        'number-control',
                                        'input-numeral',
                                        'col-xs-8',
                                        { filled: this.state.date ? moment(this.state.date).format('MM/DD/YYYY') : this.state.dateHolder },
                                    )}
                                    autoComplete={false}
                                    value={this.state.date ? moment(this.state.date).format('MM/DD/YYYY') : this.state.dateHolder}
                                    placeholder="mm/dd/yyyy"
                                    options={{
                                        date: true,
                                        datePattern: ['m', 'd', 'Y']
                                    }}
                                    onChange={this.handleDateChange}
                                /><button className="fa fa-calendar col-xs-1 btn calendarIcon" style={{marginLeft:'12px'}} onClick={this.handleOpenCalendar}></button>
                                   {this.state.openC && <DayPicker
                                    classNames={{
                                        root: "DayPicker",
                                        day: "DayPicker-Day",
                                        selected: "DayPicker-Day--selected",
                                        disabled: "DayPicker-Day--disabled",
                                    }}
                                    captionLayout="dropdown"
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    defaultMonth={modifiedDate instanceof Date && !Number.isNaN(modifiedDate.getTime())
                                        ? modifiedDate : ''}
                                    startMonth={new Date(new Date().getFullYear() - 1, 0)}
                                    endMonth={new Date(new Date().getFullYear() + 10, 12)}
                                    selected={this.state.date}
                                    onSelect={(inDate) => {
                                        this.setState({
                                            date: inDate
                                        })
                                    }}
                                    placeholder={'mm/dd/yyyy'}
                                    onDayClick={this.handleDate}
                                    mode="single"
                                   />}
                                   </div></div>)
                                    }
                                </span>
                            </div>
                        </Col>
                    </Row>}
                </div>
            </div>
        )
    }
}

export default MinimumPremium